import api from "src/configs/api";
import {
  GET_TEST_PACKAGES,
  GET_TEST_PACKAGE_DETAIL,
  CREATE_TEST_PACKAGE,
  EDIT_TEST_PACKAGE,
  GET_TEST_SEQUENCE_TAGS,
  UPDATE_TEST_SEQUENCE_TAGS,
  GET_TEST_PACKAGE_FILES_HISTORIES,
} from "src/constant/endpoint";

const getTestPackages = async (params) => await api.get(GET_TEST_PACKAGES, { params }).then((response) => response?.data?.data);

const getTestPackageDetail = async (id) => await api.get(GET_TEST_PACKAGE_DETAIL(id)).then((response) => response?.data?.data);

const getFilesHistoryTestPackageDetail = async (params) =>
  await api.get(GET_TEST_PACKAGE_FILES_HISTORIES, { params }).then((response) => response?.data?.data);

const createTestPackage = ({ data }) => api.post(CREATE_TEST_PACKAGE, { data }).then((response) => response?.data);

const editTestPackage = async ({ data }) => {
  const { testPackageId, ...restData } = data;
  const response = await api.put(EDIT_TEST_PACKAGE(testPackageId), { data: restData });
  return response?.data;
};

const getTestSequenceTags = (id) => api.get(GET_TEST_SEQUENCE_TAGS(id)).then((response) => response?.data);

const saveTestSequenceTags = (id, tags) => api.post(UPDATE_TEST_SEQUENCE_TAGS(id), { data: tags }).then((response) => response?.data);

export {
  getTestPackages,
  getTestPackageDetail,
  getFilesHistoryTestPackageDetail,
  createTestPackage,
  editTestPackage,
  getTestSequenceTags,
  saveTestSequenceTags,
};
